"use client";

import dynamic from "next/dynamic";

const InteractiveAppShowcase = dynamic(
  () =>
    import("./InteractiveAppShowcase").then(mod => ({
      default: mod.InteractiveAppShowcase,
    })),
  {
    loading: () => (
      <div className="mx-auto min-h-[420px] w-full max-w-6xl animate-pulse rounded-2xl bg-gray-100" />
    ),
  }
);

export default InteractiveAppShowcase;
